<div class="component-viewer">
    <mat-card class="mat-elevation-z8">
        <mat-card-header style="display: inline;">
            <div class="row w-100">
                <div class="col-6 text-start">
                    <h2 class="mb-0">Prizes</h2>
                </div>
                <div class="col-6 text-end">
                    <button *ngIf="selectedIteration" mat-raised-button class="pull-right"
                    [routerLink]="['../prize', 'create', searchKey]">Add <mat-icon>add</mat-icon></button>
                </div>
            </div>
        </mat-card-header>
        <mat-card-content>
            <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
            <gt-table *ngIf="true" [loading]="isLoading" [defaultPageSize]="15" [updateFilterEvent]="updateFilterEvent"
                [filter]="filter" [data]="prizes" (filterChanged)="getPrizes()" (filterReset)="resetFilter()">
            </gt-table>
            <table mat-table [dataSource]="prizes">
                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef> Name </th>
                    <td mat-cell *matCellDef="let prize"> <a
                        [routerLink]="['../prize', 'details', prize.id]">{{prize.name}}</a> </td>
                </ng-container>
                <ng-container matColumnDef="description">
                    <th mat-header-cell *matHeaderCellDef> Description </th>
                    <td mat-cell *matCellDef="let prize"> {{prize.description}} </td>
                </ng-container>
                <ng-container matColumnDef="value">
                    <th mat-header-cell *matHeaderCellDef> Value </th>
                    <td mat-cell *matCellDef="let prize"> ${{prize.value}} </td>
                </ng-container>
                <ng-container matColumnDef="expenseCost">
                    <th mat-header-cell *matHeaderCellDef> Expense Cost </th>
                    <td mat-cell *matCellDef="let prize"> ${{prize.expenseCost}} </td>
                </ng-container>
                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let prize">
                        <a mat-stroked-button *ngIf="canEditOrDelete()"
                            [routerLink]="['../prize/edit/', prize.id]">
                            Edit <mat-icon>edit</mat-icon>
                        </a>&nbsp;
                        <button mat-stroked-button class="warning" *ngIf="canEditOrDelete()" (click)="delete(prize)">
                            Delete <mat-icon>delete</mat-icon>
                        </button>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </mat-card-content>
    </mat-card>
</div>